var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconQuote = function SvgIconQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.034 6v14.782C28.034 32.19 35.496 39.922 46 42l1.99-4.302C43.126 35.864 40 30.422 40 26h8V6zM0 6v14.782C0 32.19 7.496 39.924 18 42l1.992-4.302C15.126 35.864 12 30.422 12 26h7.966V6z"
  })));
};
export default SvgIconQuote;